import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchClient,
  fetchHomeSummary,
  fetchPoiCount,
  fetchHomeOrganisations,
  fetchProspectsToWatch,
  setHomeDateRange,
  setHomeDateRangeAllTime,
  fetchWhereYourCustomersHaveBeen,
  setDateRangePreset,
  fetchBiggestMovers,
} from '../store/actions/home-actions';

import { fetchBoundaries } from '../store/actions/location-actions';

import Header from './Header';
import HomeSummary from '../components/HomeSummary';
import LoadingContainer from '../components/LoadingContainer';
import BarGraph from '../components/BarGraph';
import TopTenOrganisations from '../components/TopTenOrganisations';
import ProspectsToWatch from '../components/ProspectsToWatch';
import BiggestMovers from '../components/BiggestMovers';
import CopyrightAndVersion from '../components/CopyrightAndVersion';
import SelectionNotAvailable from '../components/SelectionNotAvailable';

import { isDataAvailable } from '../utilities/helpers';

const mapStateToProps = ({ home, client, locations }) => ({
  ...home,
  clientName: client.name,
  firstEventTS: client.firstEventTS,
  totalDataDateRangeInDays: client.totalDataDateRangeInDays,
  ...locations,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setHomeDateRange,
      setHomeDateRangeAllTime,
      fetchClient,
      fetchHomeSummary,
      fetchPoiCount,
      fetchHomeOrganisations,
      fetchProspectsToWatch,
      fetchWhereYourCustomersHaveBeen,
      setDateRangePreset,
      fetchBiggestMovers,
      fetchBoundaries,
    },
    dispatch
  );
class Home extends React.Component {
  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.clientLoaded === false && this.props.clientLoaded === true) {
      this.props.setHomeDateRange(
        moment().subtract(30, 'days').startOf('day').format(),
        moment().subtract(1, 'days').endOf('day').format(),
        moment
          .max(
            moment().subtract(60, 'days').startOf('day'),
            moment(this.props.firstEventTS)
          )
          .format(),
        moment().subtract(31, 'days').endOf('day').format()
      );

      this.loadData();
    }
  };

  setDateRange = (dateRange) => {
    this.props.setDateRangePreset(dateRange);
    if (dateRange === 'last30Days') {
      this.props.setHomeDateRange(
        moment().subtract(30, 'days').startOf('day').format(),
        moment().subtract(1, 'days').endOf('day').format(),
        moment
          .max(
            moment().subtract(60, 'days').startOf('day'),
            moment(this.props.firstEventTS)
          )
          .format(),
        moment().subtract(31, 'days').endOf('day').format()
      );
    } else if (dateRange === 'lastMonth') {
      this.props.setHomeDateRange(
        moment().subtract(1, 'months').startOf('month').format(),
        moment().subtract(1, 'months').endOf('month').format(),
        moment
          .max(
            moment().subtract(2, 'months').startOf('month'),
            moment(this.props.firstEventTS)
          )
          .format(),
        moment
          .max(
            moment().subtract(2, 'months').endOf('month'),
            moment(this.props.firstEventTS)
          )
          .format()
      );
    } else if (dateRange === 'allTime') {
      let DateDiffFromFirstEventInDays =
        moment()
          .subtract(1, 'days')
          .endOf('day')
          .diff(moment(this.props.firstEventTS), 'days') + 1;
      DateDiffFromFirstEventInDays =
        DateDiffFromFirstEventInDays > 365
          ? (DateDiffFromFirstEventInDays = 365)
          : DateDiffFromFirstEventInDays;
      this.props.setHomeDateRangeAllTime(
        moment()
          .subtract(DateDiffFromFirstEventInDays, 'days')
          .startOf('day')
          .format(),
        moment().subtract(1, 'days').endOf('day').format()
      );
    }

    this.props.fetchProspectsToWatch();
    this.props.fetchHomeSummary();
    this.props.fetchPoiCount();
    this.props.fetchHomeOrganisations();
    this.props.fetchWhereYourCustomersHaveBeen();
    this.props.fetchBiggestMovers();
  };

  loadData = () => {
    this.props.fetchBoundaries();
    this.props.fetchHomeSummary();
    this.props.fetchHomeOrganisations();
    this.props.fetchProspectsToWatch();
    this.props.fetchWhereYourCustomersHaveBeen();
    this.props.fetchBiggestMovers();
    this.props.fetchPoiCount();
  };

  hasLastMonthData = () => {
    if (!this.props.clientLoaded) {
      return false;
    }

    const endOfLastMonth = moment().subtract(1, 'month').endOf('month');
    const firstEvent = moment(this.props.clientData.firstEventTS);
    return firstEvent.isBefore(endOfLastMonth);
  };

  render() {
    return (
      <div className="Home">
        <Header />
        <div className="Home_top">
          <div className="container">
            <div className="Home_title-bar">
              <div className="Home_title-bar_left">
                <h1>{this.props.clientData.name}</h1>
                <p>
                  From {moment(this.props.sinceDate).format('D MMM')} -{' '}
                  {moment(this.props.untilDate).format('D MMM')}
                </p>
              </div>
              <div className="Home_top_button-group">
                <button
                  className={
                    this.props.dateRangePreset === 'last30Days'
                      ? 'selected'
                      : ''
                  }
                  onClick={() => this.setDateRange('last30Days')}
                >
                  Last 30 days
                </button>
                <button
                  className={
                    this.props.dateRangePreset === 'lastMonth' ? 'selected' : ''
                  }
                  disabled={!this.hasLastMonthData()}
                  onClick={() => this.setDateRange('lastMonth')}
                >
                  Last month
                </button>
                <button
                  className={
                    this.props.dateRangePreset === 'allTime' ? 'selected' : ''
                  }
                  onClick={() => this.setDateRange('allTime')}
                >
                  Last 12 months
                </button>
              </div>
            </div>
            <LoadingContainer
              loading={
                !(
                  this.props.homeSummaryLoaded === true &&
                  this.props.poiCountLoaded === true
                )
              }
            >
              <HomeSummary
                {...this.props.homeSummaryData}
                poiCountData={this.props.poiCountData}
                clientName={this.props.clientName}
              />
            </LoadingContainer>
          </div>
        </div>
        <div className="Home_reports container">
          <div className="Home_reports_grid">
            <LoadingContainer
              loading={!this.props.whereYourCustomersHaveBeenLoaded}
              className="Home_reports_grid_top content-card"
            >
              {isDataAvailable(this.props.whereYourCustomersHaveBeenData) ? (
                <BarGraph
                  data={
                    this.props.whereYourCustomersHaveBeenData
                      ? this.props.whereYourCustomersHaveBeenData
                      : []
                  }
                  title="Where your customers have been..."
                  barOnScreen={10}
                  buttonOpen
                  isDataAvailable={isDataAvailable(
                    this.props.whereYourCustomersHaveBeenData
                  )}
                  total={
                    this.props.whereYourCustomersHaveBeenLoaded
                      ? this.props.whereYourCustomersHaveBeenData
                          .map(({ current }) => current)
                          .reduce((a, b) => a + b, 0)
                      : 0
                  }
                  subtitle="identifications across all sub categories"
                />
              ) : (
                <SelectionNotAvailable
                  text="Graph Currently Unavailable"
                  buttonText=""
                />
              )}
            </LoadingContainer>
            <LoadingContainer
              loading={!this.props.homeOrganisationsLoaded}
              className="Home_reports_grid_left content-card"
            >
              {isDataAvailable(this.props.homeOrganisationsData) ? (
                <React.Fragment>
                  <TopTenOrganisations
                    total={
                      this.props.homeOrganisationsData
                        ? this.props.homeOrganisationsData
                            .slice(0, 10)
                            .map(({ current }) => current)
                            .reduce((a, b) => a + b, 0)
                        : 0
                    }
                    data={
                      this.props.homeOrganisationsData
                        ? this.props.homeOrganisationsData.slice(0, 10)
                        : []
                    }
                  />
                </React.Fragment>
              ) : (
                <SelectionNotAvailable
                  text="Graph Currently Unavailable"
                  buttonText=""
                />
              )}
            </LoadingContainer>
            <LoadingContainer
              loading={!this.props.prospectsToWatchLoaded}
              className="Home_reports_grid_right-upper content-card"
            >
              <h3 className="content-card_title">Brands to watch</h3>
              <p className="content-card_subtitle">
                Percentage of {this.props.clientName} unique devices identified
                at your selected brands
              </p>
              {isDataAvailable(this.props.prospectsToWatchData) ? (
                <React.Fragment>
                  <ProspectsToWatch
                    data={
                      this.props.prospectsToWatchData
                        ? this.props.prospectsToWatchData.slice(0, 6)
                        : []
                    }
                  />
                </React.Fragment>
              ) : (
                <SelectionNotAvailable
                  text="Graph Currently Unavailable"
                  buttonText=""
                />
              )}
            </LoadingContainer>
            <LoadingContainer
              loading={!this.props.biggestMoversLoaded}
              className="Home_reports_grid_right-lower content-card"
            >
              <h3 className="content-card_title">Biggest movers</h3>
              {isDataAvailable(this.props.biggestMoversData) ? (
                <BiggestMovers
                  data={
                    this.props.biggestMoversData
                      ? this.props.biggestMoversData
                      : {
                          organisations: { top: [], bottom: [] },
                          subcategories: { top: [], bottom: [] },
                        }
                  }
                />
              ) : (
                <SelectionNotAvailable
                  text="Graph Currently Unavailable"
                  buttonText=""
                />
              )}
            </LoadingContainer>
          </div>
        </div>
        <CopyrightAndVersion />
      </div>
    );
  }
}

Home.propTypes = {
  clientLoaded: PropTypes.bool.isRequired,
  fetchBiggestMovers: PropTypes.func.isRequired,
  fetchClient: PropTypes.func.isRequired,
  fetchHomeOrganisations: PropTypes.func.isRequired,
  fetchHomeSummary: PropTypes.func.isRequired,
  fetchProspectsToWatch: PropTypes.func.isRequired,
  fetchBoundaries: PropTypes.func.isRequired,
  fetchWhereYourCustomersHaveBeen: PropTypes.func.isRequired,
  firstEventTS: PropTypes.string.isRequired,
  homeSummaryLoaded: PropTypes.bool.isRequired,
  setDateRangePreset: PropTypes.func.isRequired,
  setHomeDateRange: PropTypes.func.isRequired,
  setHomeDateRangeAllTime: PropTypes.func.isRequired,
  fetchPoiCount: PropTypes.func.isRequired,
  totalDataDateRangeInDays: PropTypes.number.isRequired,
  clientName: PropTypes.string.isRequired,

  sinceDate: PropTypes.string,
  untilDate: PropTypes.string,
  prevSinceDate: PropTypes.string,
  prevUntilDate: PropTypes.string,
  poiCountLoaded: PropTypes.bool,

  /* eslint-disable react/forbid-prop-types */
  dateRangePreset: PropTypes.any.isRequired,
  allTimeDateRange: PropTypes.any.isRequired,
  biggestMoversData: PropTypes.any.isRequired,
  biggestMoversLoaded: PropTypes.any.isRequired,
  clientData: PropTypes.any.isRequired,
  homeOrganisationsData: PropTypes.any.isRequired,
  homeOrganisationsLoaded: PropTypes.any.isRequired,
  homeSummaryData: PropTypes.any.isRequired,
  organisationsDateRangeLoaded: PropTypes.any,
  prospectsToWatch: PropTypes.any,
  prospectsToWatchData: PropTypes.any.isRequired,
  prospectsToWatchLoaded: PropTypes.any.isRequired,
  whereYourCustomersHaveBeenData: PropTypes.any.isRequired,
  whereYourCustomersHaveBeenLoaded: PropTypes.any.isRequired,

  poiCountData: PropTypes.object,
  /* eslint-enable react/forbid-prop-types */
};

Home.defaultProps = {
  untilDate: undefined,
  sinceDate: undefined,
  prevSinceDate: undefined,
  prevUntilDate: undefined,
  organisationsDateRangeLoaded: undefined,
  prospectsToWatch: undefined,
  poiCountData: {},
  poiCountLoaded: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
